import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
    return (
        <section className="how-section">
            <div className="how-container">
                <div className="how-header">
                    <h2 className="how-title">How does it work?</h2>
                    <p className="how-subtitle">
                        Plan, shoot, edit.
                    </p>
                </div>

                <div className="how-steps-wrapper">
                    <div className="how-dotted-line">
                        <img src="https://cdn.rareblocks.xyz/collection/celebration/images/steps/2/curved-dotted-line.svg" alt="" />
                    </div>

                    <div className="how-steps-grid">
                        <div className="how-step">
                            <div className="how-step-number">
                                <span>1</span>
                            </div>
                            <h3 className="how-step-title">Better pre-production</h3>
                            <p className="how-step-text">
                                Showing up more prepared to execute is the first step to streamlining your process.
                            </p>
                        </div>

                        <div className="how-step">
                            <div className="how-step-number">
                                <span>2</span>
                            </div>
                            <h3 className="how-step-title">Live take indexing</h3>
                            <p className="how-step-text">
                                Keep track of where the good sections are in the moment. After filming, Viddy generates an Editmap with your shoot data. 
                            </p>
                        </div>

                        <div className="how-step">
                            <div className="how-step-number">
                                <span>3</span>
                            </div>
                            <h3 className="how-step-title">Streamlined edits</h3>
                            <p className="how-step-text">
                                Sync your Editmap with your raw footage and instantly identify the usable moments.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
}

export default HowItWorks;
